module.exports = __webpack_public_path__ + "media/assets/avatars/b-san-img-6c4ee3bedc0fab26d1c54b164b9c6443.svg";